import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  ListItemText,
  TextField
} from "@mui/material";
import { primaryBlueColor } from "../common/commonButtonStyles";

//inline styles
const InlineStyles = {
  TableHeader: {
    backgroundColor: primaryBlueColor,
    color: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
    height: "50px",
  },
  TableCells: {
    color: "white",
    fontSize: "14px",
    fontWeight: "600",
    height: "50px",
    padding: "12px 16px",
    width: "300px",
  },
  TableBodyRows: {
    border: "1px solid #e0e0e0",
    marginTop: "0px",
    paddingTop: "15px",
    verticalAlign: "top",
    "&:hover": {
      backgroundColor: "rgba(22, 114, 222, 0.02)",
    },
  },
  TableBodyRowCells: {
    height: "20px",
    padding: "12px 16px",
  },
  chaserIndicatorTableCell: {
    height: "auto",
    width: "200px",
    padding: "12px 16px",
  },
  chaserIndicator: {
    position: "relative",
    width: "100%",
    minWidth: "200px",
    maxHeight: "40px"
  },
  MoreVertIconStyle: {
    color: primaryBlueColor,
    background: "transparent",
    cursor: "pointer",
    transform: "rotate(90deg)",
  },
};
export const AddChaserIndicatorDetails = ({
  // statuses,
  handleInputChange,
  row,
  viewMode,
  validationStatus,
  // usersList,
  // handleEscalationUserChange,
}) => {
  return (
    <Table sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: primaryBlueColor }}>
          <TableCell sx={InlineStyles.TableCells}>
            Green to Yellow Duration
          </TableCell>
          <TableCell sx={InlineStyles.TableCells}>
            Yellow to Red Duration
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow sx={InlineStyles.TableBodyRows}>
          <TableCell sx={InlineStyles.chaserIndicatorTableCell}>
            <TextField
              value={row.green_to_yellow}
              onChange={(e) => handleInputChange('green_to_yellow', e.target.value)}
              sx={{
                ...InlineStyles.chaserIndicator,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d0d0d0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#999",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: primaryBlueColor,
                  },
                },
              }}
              size="small"
              placeholder='Enter Details Here'
              disabled={viewMode}
              fullWidth
            />
            {validationStatus?.green_to_yellow && (
              <span style={{ color: '#d32f2f', fontSize: "12px", marginTop: "4px", display: "block" }}>
                {validationStatus?.green_to_yellow}
              </span>
            )}
          </TableCell>

          <TableCell sx={InlineStyles.chaserIndicatorTableCell}>
            <TextField
              value={row.yellow_to_red}
              onChange={(e) => handleInputChange('yellow_to_red', e.target.value)}
              sx={{
                ...InlineStyles.chaserIndicator,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#d0d0d0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#999",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: primaryBlueColor,
                  },
                },
              }}
              size="small"
              placeholder='Enter Details Here'
              disabled={viewMode}
              fullWidth
            />
            {validationStatus?.yellow_to_red && (
              <span style={{ color: '#d32f2f', fontSize: "12px", marginTop: "4px", display: "block" }}>
                {validationStatus?.yellow_to_red}
              </span>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
